export const getPlaygroundUrl = (playgroundId: string) =>
  `${window.location.origin}/p/${playgroundId}`;
